export default "__VITE_ASSET__DqxLQQQ___"